var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "pointer",
          on: {
            click: function($event) {
              _vm.$router.push({
                name: "checkout",
                params: { order_id: _vm.order.id }
              })
            }
          }
        },
        [
          _c("floating-warning", {
            attrs: {
              title: "Você ainda não efetuou o pagamento deste pedido!",
              message: "Clique aqui para efetuar o pagamento do pedido.",
              positionY: "bottom",
              positionX: "center",
              visible: _vm.canGoToCheckout(_vm.order)
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "title" }, [
        _vm._v("\n    pedido\n    "),
        _vm.order.cycle_id
          ? _c(
              "div",
              { staticClass: "btn bg-purple" },
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: { name: "cycle", params: { id: _vm.order.cycle_id } }
                    }
                  },
                  [_vm._v("\n        ir para a assinatura\n      ")]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.canGoToCheckout(_vm.order)
          ? _c(
              "div",
              { staticClass: "btn bg-purple" },
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: "checkout",
                        params: { order_id: _vm.order.id }
                      }
                    }
                  },
                  [_vm._v("\n        efetuar pagamento\n      ")]
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "minor-title" }, [_vm._v("local")]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("p", [
          _c("b", [_vm._v("Rua:")]),
          _vm._v("\n      " + _vm._s(_vm.order.address.street) + "\n    ")
        ]),
        _vm._v(" "),
        _c("p", [
          _c("b", [_vm._v("CEP:")]),
          _vm._v("\n      " + _vm._s(_vm.order.address.zip_code) + "\n    ")
        ]),
        _vm._v(" "),
        _c("p", [
          _c("b", [_vm._v("Nº:")]),
          _vm._v(
            "\n      " + _vm._s(_vm.order.address.street_number) + "\n    "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _c("b", [_vm._v("Complemento:")]),
          _vm._v(" "),
          _vm.order.address.complement === ""
            ? _c("span", [_vm._v("sem complemento")])
            : _c("span", [_vm._v(_vm._s(_vm.order.address.complement))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("p", [
          _c("b", [_vm._v("Bairro:")]),
          _vm._v(
            "\n      " +
              _vm._s(_vm.order.address.district.display_name) +
              "\n    "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _c("b", [_vm._v("Cidade:")]),
          _vm._v(
            "\n      " +
              _vm._s(_vm.order.address.district.city.display_name) +
              "\n    "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _c("b", [_vm._v("Estado:")]),
          _vm._v(
            "\n      " +
              _vm._s(_vm.order.address.district.city.state.code) +
              "\n    "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _c("b", [_vm._v("País:")]),
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.order.address.district.city.state.country.display_name
              ) +
              "\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("p", [
          _c("b", [_vm._v("Referência de localização:")]),
          _vm._v(" "),
          _vm.order.address.reference === ""
            ? _c("span", [_vm._v("sem referência")])
            : _c("span", [_vm._v(_vm._s(_vm.order.address.reference))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "p",
          [
            _c("b", [_vm._v("Geolocalização:")]),
            _vm._v(" "),
            _vm.lat && _vm.lng
              ? _c("google-maps", {
                  attrs: {
                    name: "geolocation",
                    lat: _vm.lat,
                    lng: _vm.lng,
                    withAutocomplete: false
                  }
                })
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("p", [
          _c("b", [_vm._v("Informações sobre a limpeza:")]),
          _vm._v("\n      " + _vm._s(_vm.order.description) + "\n    ")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-30" }, [
        _c("div", [
          _c("div", { staticClass: "minor-title" }, [_vm._v("dia")]),
          _vm._v(" "),
          _c("p", { staticClass: "mt-0 mb-20" }, [
            _vm._v(
              _vm._s(
                _vm._f("formatDate")(
                  _vm.order.schedule_event.starts_at,
                  "dddd[, ]DD/MM/YYYY"
                )
              )
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "minor-title" }, [_vm._v("duração")]),
          _vm._v(" "),
          _c("p", { staticClass: "mt-0 mb-20" }, [
            _vm._v(
              _vm._s(
                _vm._f("secToHours")(_vm.order.schedule_event.duration, true)
              )
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "minor-title" }, [_vm._v("início")]),
          _vm._v(" "),
          _c("p", { staticClass: "mt-0 mb-20" }, [
            _vm._v(
              _vm._s(
                _vm._f("formatDate")(_vm.order.schedule_event.starts_at, "H[h]")
              )
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "minor-title" }, [_vm._v("profissional")]),
          _vm._v(" "),
          _c("p", { staticClass: "mt-0 mb-20" }, [
            _vm._v(
              _vm._s(_vm.order.professional.account.first_name) +
                " " +
                _vm._s(_vm.order.professional.account.last_name)
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", [
          _c("div", { staticClass: "minor-title" }, [
            _vm._v("status do pedido")
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "mt-0 mb-20" }, [
            _vm._v(_vm._s(_vm._f("getTranslatedName")(_vm.order.status)))
          ])
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "minor-title" }, [
            _vm._v("valor do pedido")
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "mt-0 mb-20" }, [
            _vm._v(_vm._s(_vm._f("intToCurrency")(_vm.order.total)))
          ])
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "minor-title" }, [
            _vm._v("total de desconto")
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "mt-0 mb-20" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm._f("intToCurrency")(_vm.order.amount.subtotal.discount)
                ) +
                "\n        "
            ),
            _vm.order.coupon
              ? _c("span", { staticClass: "text-purple" }, [
                  _vm._v("\n          (cupom\n          "),
                  _c("b", [_vm._v(_vm._s(_vm.order.coupon.name))]),
                  _vm._v(")\n        ")
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "minor-title" }, [
            _vm._v("Total do pedido")
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "mt-0 mb-20" }, [
            _vm._v(_vm._s(_vm._f("intToCurrency")(_vm.order.amount.total)))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("holiday-warning", {
        attrs: { day: _vm.order.schedule_event.starts_at }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a0fba9b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a0fba9b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Order/Data.vue
// module id = null
// module chunks = 